import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { MAIN_CURRENCY } from '@okletsplay/core';
import { RecentWinnerEntity } from 'app/interfaces/entity';
import classNames from 'classnames';
import { FormatCurrency, FormatCurrencyType } from 'shared/components/Format/Currency';
import { UserAvatar } from 'shared/components/UserAvatar';
import { useStyles } from './RecentWinnerCard.styles';

interface RecentWinnerCardProps {
  winner: RecentWinnerEntity;
}

export const RecentWinnerCard: FC<RecentWinnerCardProps> = ({ winner }) => {
  const { classes } = useStyles();

  if (!winner) {
    return null;
  }

  const currency = MAIN_CURRENCY;

  return (
    <Box className={classes.root}>
      <Box className={classes.avatar}>
        <UserAvatar user={winner.user} />
      </Box>
      <Typography className={classNames(classes.text, classes.userName)}>
        {winner.user.userName}
      </Typography>
      <Typography className={classes.text}>won</Typography>
      <Typography className={classNames(classes.text, classes.winningAmount)}>
        <FormatCurrency
          amount={winner.winningAmount}
          type={FormatCurrencyType.Crypto}
          currency={currency}
        />
      </Typography>
    </Box>
  );
};
